// extracted by mini-css-extract-plugin
export var buyLink = "styles-module__buyLink___oBMzM";
export var container = "styles-module__container___sXX9E";
export var contentContainer = "styles-module__contentContainer___QQT90";
export var logoProImage = "styles-module__logoProImage___GoXAm";
export var text = "styles-module__text___LfAdf";
export var title = "styles-module__title___kHv40";
export var upperContainer = "styles-module__upperContainer___vbNpX";